export function createInstance<T>(data: any, mappings: any, type: any): T | null {
    if (!mappings)
        mappings = [];
    if (!data)
        return null;

    const mappingIndexName = "__mappingIndex";
    if (data[mappingIndexName])
        return mappings[data[mappingIndexName]].target as T;

    data[mappingIndexName] = mappings.length;

    let result: any = new type();
    mappings.push({ source: data, target: result });
    result.init(data, mappings);
    return result;
}